import { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import type { QRCodeConfig } from '../types';
import { renderQRCode } from '../utils/qrRenderer';

export interface QRPreviewHandle {
  download: (filename?: string) => void;
  getCanvas: () => HTMLCanvasElement | null;
}

interface QRPreviewProps {
  config: QRCodeConfig;
}

export const QRPreview = forwardRef<QRPreviewHandle, QRPreviewProps>(
  function QRPreview({ config }, ref) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const displaySize = 300;

    useImperativeHandle(ref, () => ({
      download(filename = 'qrcode.png') {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const highRes = document.createElement('canvas');
        const scale = 2;
        highRes.width = config.size * scale;
        highRes.height = config.size * scale;
        renderQRCode(highRes, config).then(() => {
          const link = document.createElement('a');
          link.download = filename;
          link.href = highRes.toDataURL('image/png');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      },
      getCanvas() { return canvasRef.current; },
    }));

    useEffect(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      if (!config.text.trim()) {
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.fillStyle = '#f5f5f5';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        return;
      }
      renderQRCode(canvas, config).catch(console.error);
    }, [config]);

    return (
      <div className="qr-preview-wrapper">
        {config.text.trim() ? (
          <canvas ref={canvasRef} width={displaySize} height={displaySize} className="qr-canvas" />
        ) : (
          <div className="qr-placeholder">
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <rect x="7" y="7" width="3" height="3" />
              <rect x="14" y="7" width="3" height="3" />
              <rect x="7" y="14" width="3" height="3" />
              <rect x="14" y="14" width="3" height="3" />
            </svg>
            <p>输入内容以生成二维码</p>
          </div>
        )}
      </div>
    );
  },
);
